// Browser-reachable service URL helpers.
// A frontend opened from another PC/phone must not call that device's own localhost.

const LOOPBACK_HOSTS = new Set(['localhost', '127.0.0.1', '0.0.0.0', '::1']);

export function isLoopbackHost(hostname = '') {
  return LOOPBACK_HOSTS.has(String(hostname || '').trim().toLowerCase());
}

export function isBrowserOnLoopback() {
  if (typeof window === 'undefined' || !window.location) return true;
  return isLoopbackHost(window.location.hostname);
}

export function toBrowserReachableUrl(value = '') {
  const raw = String(value || '').trim().replace(/\/+$/, '');
  if (!raw || typeof window === 'undefined' || !window.location) return raw;

  try {
    const parsed = new URL(raw);
    if (!['http:', 'https:', 'ws:', 'wss:'].includes(parsed.protocol)) return raw;
    if (!isBrowserOnLoopback() && isLoopbackHost(parsed.hostname)) {
      parsed.hostname = window.location.hostname;
    }
    return parsed.toString().replace(/\/+$/, '');
  } catch (_) {
    return raw;
  }
}

export function resolveServiceBase(configuredValue, options = {}) {
  const configured = toBrowserReachableUrl(configuredValue);
  if (configured) return configured;

  if (typeof window === 'undefined' || !window.location) return '';
  const { protocol, hostname, port, origin } = window.location;
  const devFrontPorts = new Set(['3001', '3002', '5173', '5174']);
  const devPort = Number(options.devPort || 0);

  if (process.env.NODE_ENV === 'development' && devPort && devFrontPorts.has(String(port || ''))) {
    return `${protocol}//${hostname}:${devPort}`;
  }
  return options.fallbackToOrigin === false ? '' : String(origin || '').replace(/\/+$/, '');
}

export function resolveLobbyApiBase() {
  return resolveServiceBase(
    process.env.REACT_APP_API_BASE_URL ||
      process.env.REACT_APP_API_BASE ||
      process.env.REACT_APP_LOBBY_API_BASE_URL ||
      process.env.REACT_APP_LOBBY_API_BASE ||
      '',
    { devPort: 3000, fallbackToOrigin: true },
  );
}

export function resolveLobbySocketBase() {
  return resolveServiceBase(
    process.env.REACT_APP_LOBBY_SOCKET_URL || process.env.REACT_APP_SOCKET_URL || '',
    { devPort: 3000, fallbackToOrigin: true },
  );
}

export function resolveGameSocketBaseFromEnv() {
  return resolveServiceBase(
    process.env.REACT_APP_GAME_SOCKET_URL ||
      process.env.REACT_APP_GAME_BASE_URL ||
      process.env.REACT_APP_GAME_URL ||
      '',
    { devPort: 4000, fallbackToOrigin: false },
  );
}
